import styled from '@emotion/styled';
import { ListIcon, ListItem, Link } from '@chakra-ui/react';

export const MenuItem = styled(ListItem)`
  display: flex;
  transition: color 0.2s linear;
  flex-direction: column;
  /* color: #ede5e5; */

  &.active > a,
  &:hover > a {
    background: #bbbfc72b;
    border-radius: 8px;
  }
`;

export const MenuLink = styled(Link)`
  display: flex;
  flex-grow: 1;
  align-items: center;
  padding: 10px 0;
  font-size: small;
  outline: none;
  margin: 0 10px;

  &:hover {
    text-decoration: none;
  }
`;

export const MenuIcon = styled(ListIcon)`
  margin: 0 10px 0 10px;
`;


export const LinkText = styled('div')`
  transition: width 0.2s linear;
  overflow: hidden;

  &.collapsed {
    width: 0;
  }

  span {
    white-space: break-spaces;
    display: block;
    width: 122px;
  }
`;
